import { createGloballyExclusiveHandler } from '../../../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { uiManager } from '../../../../EntryMobile.ts';
import { UILobbyController } from '../../../../../../shared/scripts/ui_html/lobby/UILobbyController.ts';
import { RoomStep } from '../../../room/UIMCreateRoomController.ts';
import { SocketLobbySend } from '../../../../../../shared/scripts/socket/SocketLobbySend.ts';
import { ClientUserState } from '../../../../../../shared/scripts/ClientUserState.ts';
import { setElementOnClick } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIMLobbyController extends UILobbyController {
    // eslint-disable-next-line class-methods-use-this
    async handleJoinRoom(roomId) {
        uiManager.createRoomController.setShowPageOnNextUpdate(RoomStep.RoomPage);
        await SocketLobbySend.accessGameFromLink(roomId);
    }
    constructor(){
        super();
        if (this.createRoomButton) {
            setElementOnClick(this.createRoomButton, createGloballyExclusiveHandler(async ()=>{
                AudioManager.play(AudioType.JoinRoom);
                await ClientUserState.requireUser();
                uiManager.createRoomController.initCreateRoomView();
            }));
        }
        setElementOnClick(this.joinRoomButton, createGloballyExclusiveHandler(()=>{
            this.openJoinRoomPopup();
        }));
    }
}
